import createReactComponent from '../createReactComponent';
export default createReactComponent('move-horizontal', 'MoveHorizontal', [["path",{"d":"m18 16 4-4-4-4m4 4H2m4 4-4-4 4-4","key":"svg-0"}]]);